import { logger } from "@/utils/logger";
/** Vuex: SAVE_PLAN */
export function savePlanEntry(state, { hatNo, gunTipi, plan }) {
    if (!state.savedPlans[hatNo]) {
        state.savedPlans[hatNo] = {};
    }
    state.savedPlans[hatNo][gunTipi] = plan;
}
/** Vuex: SET_ANALYSIS_DATA (+ türev state patch) */
export function applyAnalysisData(state, data) {
    state.analysisData = data;
    if (!data)
        return;
    if (data.gidis) {
        state.gidisVerileri = {
            servisler: data.gidis.servisler || [],
            istatistikler: data.gidis.istatistikler || {},
            optimizasyonSonuclari: data.gidis.optimizasyonSonuclari || {},
            yolcuSayilari: data.gidis.yolcuSayilari || [],
            duraklar: data.gidis.duraklar || [],
            hatBilgileri: data.gidis.hatBilgileri || {},
            grafikVerileri: data.gidis.grafikVerileri || {},
        };
    }
    if (data.donus) {
        state.donusVerileri = {
            servisler: data.donus.servisler || [],
            istatistikler: data.donus.istatistikler || {},
            optimizasyonSonuclari: data.donus.optimizasyonSonuclari || {},
            yolcuSayilari: data.donus.yolcuSayilari || [],
            duraklar: data.donus.duraklar || [],
            hatBilgileri: data.donus.hatBilgileri || {},
            grafikVerileri: data.donus.grafikVerileri || {},
        };
    }
    state.hatVerileri = {
        gidis: data.gidis?.hatBilgileri || {},
        donus: data.donus?.hatBilgileri || {},
        gidisDuraklar: data.gidis?.duraklar || [],
        donusDuraklar: data.donus?.duraklar || [],
        duraklar: data.duraklar || [],
    };
    state.yolcuVerileri = {
        gidis: data.gidis?.yolcuSayilari || [],
        donus: data.donus?.yolcuSayilari || [],
        toplam: data.yolcuSayilari || {},
    };
    state.grafikVerileri = {
        gidis: data.gidis?.grafikVerileri || {},
        donus: data.donus?.grafikVerileri || {},
        toplam: data.grafikVerileri || {},
    };
    state.modelVerileri = {
        gidis: data.gidis?.modelSonuclari || {},
        donus: data.donus?.modelSonuclari || {},
        toplam: data.modelSonuclari || {},
    };
    state.dolulukHedefi = data.doluluk;
    state.optimizasyonParametreleri = data.optimizasyonSonuclari || {};
}
function mapServislerWithParkur(servisler, parkurByTime) {
    return servisler.map((servis) => {
        const [hour] = servis.baslangic.split(":").map(Number);
        const timeKey = `${String(hour).padStart(2, "0")}_0`;
        const parkurSuresi = parkurByTime?.[timeKey] || 45;
        logger.debug(`Servis parkur süresi güncelleniyor - Saat: ${hour}, Süre:`, parkurSuresi);
        return { ...servis, sure: parkurSuresi };
    });
}
/** Vuex: SET_SEFER_PLANI */
export function applySeferPlani(state, plan) {
    if (!plan) {
        state.seferPlani = plan;
        return;
    }
    const next = { ...plan };
    if (next.gidis?.servisler) {
        next.gidis = {
            ...next.gidis,
            servisler: mapServislerWithParkur(next.gidis.servisler, state.analysisData?.gidis?.parkur_suresi),
        };
    }
    if (next.donus?.servisler) {
        next.donus = {
            ...next.donus,
            servisler: mapServislerWithParkur(next.donus.servisler, state.analysisData?.donus?.parkur_suresi),
        };
    }
    state.seferPlani = next;
}
